import { Modal,Button,CheckBox } from "src/Components";
import { CoveredMatrixCallOption,CoveredMatrixItemInput,CreateCoveredMatrixOrderRequest } from "src/Interfaces/coveredMatrixOrder";

export const OptionsModal=({ draft,setDraft,options,baseName,onClose,newItemDefaults }: {
  newItemDefaults: Pick<CoveredMatrixItemInput,"criterionType"|"criterionValue">;
  draft: CreateCoveredMatrixOrderRequest;
  setDraft: (value: CreateCoveredMatrixOrderRequest) => void;
  options: CoveredMatrixCallOption[];
  baseName: string;
  onClose: () => void;
}) => {
  const selected=draft.items.map((item) => item.optionIsin);
  const toggle=(optionIsin: string) => {
    const exists=selected.includes(optionIsin);
    const next=exists? selected.filter((id) => id!==optionIsin):[...selected,optionIsin];
    setDraft({ ...draft,items: next.map((id) => draft.items.find((item) => item.optionIsin===id)||({ optionIsin: id,...newItemDefaults } as CoveredMatrixItemInput)) });
  };
  const optionGroups=options.reduce<Record<string,CoveredMatrixCallOption[]>>((result,option) => {
    const dueDate=option.dueDate? option.dueDate.split(/[T\s]/)[0]:"بدون سررسید";
    (result[dueDate]||=[]).push(option);
    return result;
  },{});
  return <Modal
    title="زنجیره آپشن"
    onClose={onClose}
    modalBoxClassName="!w-[1100px] !max-w-[95vw]"
    UI={<div className="p-4 flex flex-col gap-4" dir="rtl">
      <div>
        <div className="font-bold">زنجیرهٔ آپشن‌های Call</div>
        <div className="mt-1 flex justify-between text-xs text-gray-500">
          <span>نماد پایه: {baseName||"-"}</span>
          <span>انتخاب‌شده: {selected.length}</span>
        </div>
      </div>
      <div className="flex gap-1 max-h-[60vh] overflow-auto">
        {Object.entries(optionGroups).map(([dueDate,group]) => <div key={dueDate} className="w-[165px] shrink-0">
          <div className="bg-sky-50 px-2 py-2 text-xs font-semibold">سررسید {dueDate}</div>
          <div className="p-2 flex flex-col gap-1">
            {group.map((option) => {
              const isSelected=selected.includes(option.id.toString()); return <CheckBox
                key={option.id}
                name={option.id.toString()}
                checked={isSelected}
                onChange={() => toggle(option.id.toString())}
                label={`${option.name}${option.strikePrice? ` - ${Number(option.strikePrice).toLocaleString()}`:""}`}
              />;
            })}
          </div>
        </div>)}
      </div>
      <div className="flex justify-end">
        <Button
          variant="contained"
          text={`تأیید انتخاب (${selected.length})`}
          onClick={onClose}
          className="!w-32"
        />
      </div>
    </div>}
  />;
};
